import { HeroTeaser } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import { useApplicationState } from '../../../App.state';
import { getHeroTeaserTitle } from '../Wizard/journey-step-helpers';
import { SECTION_HEADING_ID } from '../../../utils/conts';
import { appConfig } from '../../../../config';
import { LocalBrands } from '../../../../shared/types';

const heroImages: Record<LocalBrands, string> = {
  audi: 'hero--audi.png',
  seat: 'hero--seat.jpg',
  cupra: 'hero--cupra.png',
  vw: 'hero--vw.png',
  vwn: 'hero--vwn.png'
};

export const getHeroTeaserPositionProps = (
  width: number
): {
  bottomCenter: boolean;
  topCenter: boolean;
} => {
  if (width <= 1920) {
    return { bottomCenter: true, topCenter: false };
  }
  return { bottomCenter: false, topCenter: true };
};

export const JourneyHeroTeaser: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { pathname } = useLocation();
  const {
    state: { currentJourneyStatus }
  } = useApplicationState();
  const { t } = useTranslation(['match-maker', 'scaffolding', 'personal-information']);

  useEffect(() => {
    const debouncedHandleResize = debounce(() => setWindowWidth(window.innerWidth), 200);
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
      debouncedHandleResize.cancel();
    };
  }, []);

  const title = getHeroTeaserTitle(t, pathname, currentJourneyStatus);
  const heroImageName = heroImages[appConfig.brandName] || 'hero--vw.png';
  const heroImage = `/images/${heroImageName}`;
  const positionProps = getHeroTeaserPositionProps(windowWidth);

  return (
    <HeroTeaser
      id={SECTION_HEADING_ID}
      className="u-mb-large"
      {...positionProps}
      title={title}
      imgProps={{
        alt: title,
        sizes: '100vw',
        src: heroImage,
        srcSet: `${heroImage} 1600w`
      }}
    />
  );
};
